export const COPING_ACTIVITIES = [
  { text: 'Deep breathing', emoji: '🌬️' },
  { text: 'Drink water', emoji: '💧' },
  { text: 'Take a walk', emoji: '🚶' },
  { text: 'Listen to music', emoji: '🎵' },
  { text: 'Call a friend', emoji: '📞' },
  { text: 'Stretch', emoji: '🧘' },
  { text: 'Journal', emoji: '📝' },
  { text: 'Meditate', emoji: '🧘‍♀️' },
  { text: 'Gratitude list', emoji: '🙏' },
  { text: 'Healthy snack', emoji: '🍎' },
  { text: 'Go outside', emoji: '🌳' },
  { text: 'Take a nap', emoji: '😴' },
  { text: 'Read a book', emoji: '📚' },
  { text: 'Tidy space', emoji: '🧹' },
  { text: 'Pet an animal', emoji: '🐕' },
  { text: 'Watch comedy', emoji: '😂' },
  { text: 'Take a bath', emoji: '🛁' },
  { text: 'Hug someone', emoji: '🤗' },
  { text: 'Dance', emoji: '💃' },
  { text: 'Draw/color', emoji: '🎨' },
  { text: 'Positive talk', emoji: '💪' },
  { text: 'Grounding', emoji: '✋' },
  { text: 'Sun exposure', emoji: '☀️' },
  { text: 'Cook a meal', emoji: '🍳' },
  { text: 'Screen break', emoji: '📵' },
  { text: 'Say no', emoji: '🚫' },
  { text: 'Ask for help', emoji: '🆘' },
  { text: 'Forgive self', emoji: '💜' },
  { text: 'Cry it out', emoji: '😢' },
  { text: 'Aromatherapy', emoji: '🌸' },
];

export const FREE_SPACE = { text: 'FREE', emoji: '⭐' };
